<template>
  <div>
    <b-form-input
      :value="value"
      @input="commitOrEmit($event)"
      :readonly="readonly"
    />
  </div>
</template>

<script>
import BaseInput from './mixins/BaseInput';

export default {
  mixins: [BaseInput],
};
</script>
